export const SEARCH_RESULT_LIMIT = 10
export const DATA_TYPES = ['chat', 'scans']
export const GenderTypes = {
  Male: 'male',
  Female: 'female',
  Other: 'other',
  Unknown: 'unknown'
}
